export const STYLES = {
  WRAPPER: 'relative',
  PREVIEW_WRAPPER_SHOW: 'block absolute w-[168px] h-[256px] p-2 rounded-[8px] bg-bw02 border-[1px] border-bw03 left-[50%] translate-x-[-50%] shadow-light top-[40px] z-10',
  PREVIEW_WRAPPER_HIDE: 'hidden',
  PREVIEW_CONTENT: 'border-[1px] border-bw03 h-full',
};
